import { Typography } from "@mui/material"
import { Stack } from "src/shared/components"
import CallMadeOutlinedIcon from "@mui/icons-material/CallMadeOutlined"
import CallReceivedOutlinedIcon from "@mui/icons-material/CallReceivedOutlined"

const DashboardBox = ({ title, value, type = "default" }: { title: string; value: string; type?: string }) => {
  return (
    <Stack
      spacing={1}
      minWidth={200}
      sx={{ p: { xs: 2, md: 3 }, flex: 1, border: (theme) => `1px solid ${theme.palette.divider}`, borderRadius: 2 }}
    >
      <Stack variant="rowCenterSpaceBetween">
        <Typography
          variant="body1"
          fontWeight={500}
          color={type === "in" ? "success" : type === "out" ? "error" : "textPrimary"}
        >
          {title}
        </Typography>
        {type === "out" && <CallMadeOutlinedIcon color="error" />}
        {type === "in" && <CallReceivedOutlinedIcon color="success" />}
      </Stack>
      <Typography variant="h1">{value}</Typography>
    </Stack>
  )
}

export default DashboardBox
